import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { fmtN } from './JoBits';

export const PoTag = ({ po, testId }) => (po
  ? <span className="font-mono text-xs" data-testid={testId}>{po}</span>
  : <Badge className="bg-gray-100 text-gray-600 border-0 font-normal whitespace-nowrap" data-testid={testId}>No PO linked</Badge>);

export const srcText = (s) => (s ? [s.document, s.supplier].filter(Boolean).join(' · ') : '');

/** Every bundle picked for the order with its Greige receipt document, supplier and Purchase Order. */
export const JoSources = ({ rows }) => (
  <div className="overflow-x-auto">
    <Table data-testid="jo-sources-table">
      <TableHeader><TableRow>{['Bundle', 'Sort no', 'Pcs', 'Greige document', 'Supplier', 'PO'].map((h) => <TableHead key={h} className="whitespace-nowrap">{h}</TableHead>)}</TableRow></TableHeader>
      <TableBody>
        {!rows.length && <TableRow><TableCell colSpan={6} className="text-center py-6 text-gray-500" data-testid="jo-sources-empty">No bundles sent yet</TableCell></TableRow>}
        {rows.map((r) => (
          <TableRow key={r.code} data-testid={`jo-source-row-${r.code}`}>
            <TableCell className="font-mono text-xs">{r.code}</TableCell>
            <TableCell className="font-mono text-xs">{r.sort_no}</TableCell>
            <TableCell className="tabular-nums">{fmtN(r.pcs)}</TableCell>
            <TableCell className="font-mono text-xs">{r.document || '—'}</TableCell>
            <TableCell className="text-xs max-w-[180px] truncate">{r.supplier || '—'}</TableCell>
            <TableCell><PoTag po={r.po_number} testId={`jo-source-po-${r.code}`} /></TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </div>
);
